import React, { useState, useEffect, useRef } from "react";
import "../../style/main.scss";
import profile from "../../assets/images/enterpre.png";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { BiChevronDown } from "react-icons/bi";

const Navbar = () => {
  const navigate = useNavigate();
  const authToken = localStorage.getItem("bearerToken");
  const authEmail = localStorage.getItem("email");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleSignOut = () => {
    localStorage.removeItem("bearerToken");
    localStorage.removeItem("email");
    navigate("/login");
    toast.success("Successfully logged out");
  };

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const closeDropdown = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", closeDropdown);
    return () => {
      document.removeEventListener("mousedown", closeDropdown);
    };
  }, []);

  return (
    <div>
      <nav className="navbar navbar-expand-lg">
        <div className="container-fluid">
          <a
            className="navbar-brand text-black fw-bold fs-4 text-orange-gradient"
            href="#"
            onClick={() => navigate("/")}
          >
            AI Restaurant Calling Agent
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <div
              className={`profile-dropdown ${dropdownOpen ? "show" : ""}`}
              ref={dropdownRef}
            >
              {authToken && (
                <>
                  <div className="dropdown-button" onClick={toggleDropdown}>
                    <img src={profile} alt="profile-image" />
                    <span className="text-black">
                      {authEmail ? authEmail : "User"}
                    </span>
                    <BiChevronDown
                      style={{ marginBottom: 1, marginLeft: 4 }}
                      color="#6759df"
                      size={28}
                    />
                  </div>

                  <div className="dropdown-menu">
                    <div
                      className="dropdown-item"
                      onClick={() => navigate("/profile")}
                    >
                      Your Profile
                    </div>
                    <div
                      className="dropdown-item"
                      onClick={() => navigate("/settings")}
                    >
                      Team Settings
                    </div>
                    <div
                      className="dropdown-item"
                      onClick={() => navigate("/integration")}
                    >
                      Integration
                    </div>
                    <div
                      className="dropdown-item"
                      onClick={() => navigate("/billing")}
                    >
                      Billing
                    </div>
                    <div className="dropdown-item" onClick={handleSignOut}>
                      Sign Out
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
